export const getTokenAndSpenderKey = (symbol: string, spender: string): string => {
    return `${symbol}-${spender}`;
};
